document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".wade-tech__item");

  items.forEach((item) => {
    const textEl = item.querySelector(".wade-tech__content");
    if (!textEl) return;

    // ❗改这里：data-content
    const rawHTML = textEl.getAttribute("data-content")?.trim();
    if (!rawHTML) return;

    // ✅ 解析 HTML，取第一个 p
    const temp = document.createElement("div");
    temp.innerHTML = rawHTML;

    const firstP = temp.querySelector("p");
    const fullText = firstP ? firstP.innerText.trim() : temp.innerText.trim(); // fallback

    if (!fullText) return;

    let isExpanded = false;

    const btn = document.createElement("button");
    btn.className = "t4s-product__technology_readm";
    btn.textContent = "Read more";

    let lineHeight = parseFloat(getComputedStyle(textEl).lineHeight);
    if (isNaN(lineHeight)) {
      const fontSize = parseFloat(getComputedStyle(textEl).fontSize);
      lineHeight = fontSize * 1.2;
    }

    const maxHeight = lineHeight * 2;

    function truncateToTwoLines() {
      textEl.innerHTML = fullText;

      if (textEl.scrollHeight <= maxHeight) {
        return false;
      }

      let words = fullText.includes(" ")
        ? fullText.split(" ")
        : fullText.split("");

      let fittedWords = [];

      for (let i = 0; i < words.length; i++) {
        fittedWords.push(words[i]);

        textEl.innerHTML = fittedWords.join(" ") + "... " + btn.textContent;

        if (textEl.scrollHeight > maxHeight) {
          fittedWords.pop();
          break;
        }
      }

      if (fittedWords.length > 0) {
        fittedWords.pop();
      }

      textEl.innerHTML = fittedWords.join(" ") + "... ";
      textEl.appendChild(btn);

      return true;
    }

    function render() {
      if (!isExpanded) {
        btn.textContent = "Read more";

        const truncated = truncateToTwoLines();

        if (!truncated) {
          textEl.textContent = fullText;
        }
      } else {
        textEl.innerHTML = fullText + " ";
        btn.textContent = "Show less";
        textEl.appendChild(btn);
      }
    }

    render();

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      isExpanded = !isExpanded;
      render();
    });
  });
});
